import React from 'react'
import {SimpleBlog, useSimpleBlogUpdate} from 'Event/template/SimpleBlog'
import {useForm} from 'react-hook-form'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import {DeepPartial} from 'lib/type-utils'
import Settings from 'Event/template/SimpleBlog/SimpleBlogConfig/Settings'
import Styling from 'Event/template/SimpleBlog/SimpleBlogConfig/Styling'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import {
  useAutoUpdate,
  useTemplateEditor,
} from 'organization/Event/TemplateEditor'
import {usePruneAssets} from 'lib/asset'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import {useAddTranslation} from 'Event/LanguageProvider'

export function SimpleBlogConfig(props: ComponentConfigProps) {
  const {showing, onClose} = props
  const update = useSimpleBlogUpdate()
  const addTranslation = useAddTranslation()
  const {control, watch, handleSubmit, formState} = useForm()
  const pruneAssets = usePruneAssets()
  const {saved} = useTemplateEditor<SimpleBlog>()

  const save = (data: DeepPartial<SimpleBlog>) => {
    const logo = data.logo
    pruneAssets({logo}, saved)

    const headerBackground = data.header?.background
    pruneAssets({background: headerBackground}, saved.header)

    const dashboardBackground = data.dashboardBackground?.image
    if (saved.dashboardBackground) {
      pruneAssets({image: dashboardBackground}, saved.dashboardBackground)
    }

    const text = replaceAtPath(data, 'header.text', '{{header_text}}')

    update({
      ...data,
      localization: addTranslation({
        header_text: text ?? '',
      }),
    })
    onClose()
  }

  useAutoUpdate({values: watch(), when: showing})

  return (
    <ComponentConfig
      showing={showing}
      onClose={onClose}
      title="Simple Blog"
      onSubmit={handleSubmit(save)}
      hasChanges={formState.isDirty}
    >
      <SettingsPanel>
        <Settings control={control} watch={watch} />
      </SettingsPanel>
      <StylingPanel>
        <Styling control={control} watch={watch} />
      </StylingPanel>
      <Footer>
        <SaveButton type="submit" />
      </Footer>
    </ComponentConfig>
  )
}
